import { atomWithStorage } from 'jotai/utils';

export type MapCenter = [number, number];

export const DEFAULT_MAP_ZOOM = 9;

const createMapViewAtoms = (key: string) => ({
    centerAtom: atomWithStorage<MapCenter | null>(`${key}Center`, null, undefined, { getOnInit: true }),
    zoomAtom: atomWithStorage<number>(`${key}Zoom`, DEFAULT_MAP_ZOOM, undefined, { getOnInit: true }),
});

export type MapViewAtoms = ReturnType<typeof createMapViewAtoms>;

export const observationMapViewState = createMapViewAtoms('wxObservationMap');
export const advisoryMapViewState = createMapViewAtoms('wxAdvisoryMap');
